import { SimpleGrid, Text, useColorModeValue, Spinner, Center } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import Information from "views/admin/profile/components/Information";

import constants from "providers/Constants";
import useAuthentication from "providers/Authentication";

export default function PersonalInformation(props) {

  const authentication = useAuthentication();

  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const { user, profile, developer, ...rest } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );

  const infoProps = { boxShadow: cardShadow };
  const isBvnDisabled = !!(profile?.bvn && profile?.bvn_verified === true && profile?.bvn === developer?.bvn);
  const handleChange = (obj, key, params = {}) => (e) => {
    obj[key] = e;
    updateProfile(key, e, params);
  };

  return (
    <Card mb={{ base: "0px", "2xl": "20px" }} {...rest}>
      {loading ? (
        <Center w='100%' minH={rest?.minH || '220px'}>
          <Spinner size="xl" />
        </Center>
      ) : (
        <>
          <SimpleGrid columns='2' gap='20px'>
            <Information
              {...infoProps}
              title={t('First Name')}
              value={user?.first_name || t('N/A')}
              onChange={handleChange(user, 'first_name')}
            />
            <Information
              {...infoProps}
              title={t('Last Name')}
              value={user?.last_name || t('N/A')}
              onChange={handleChange(user, 'last_name')}
            />
            <Information
              {...infoProps}
              title={t('Middle Name')}
              value={user?.middle_name || t('N/A')}
              onChange={handleChange(user, 'middle_name')}
            />
            <Information
              {...infoProps}
              title={t('Gender')}
              select
              select_array={['Male', 'Female']}
              value={profile?.gender || t('N/A')}
              onChange={handleChange(profile, 'gender')}
            />
            <Information
              {...infoProps}
              title={t('Email')}
              can_verify={!user.email_verified}
              verification_type='email'
              data={user}
              value={user?.email || t('N/A')}
              onChange={() => { }}
              disabled
            />
            <Information
              {...infoProps}
              title={t('Phone')}
              input_type='number'
              verification_type='phone'
              data={user}
              can_verify={!user.phone_verified}
              value={user?.phone || t('N/A')}
              onChange={() => { }}
            />
            {
              user.country_shortcode === "NG" && user.phone ? (
                <Information
                  {...infoProps}
                  title={t('BVN')}
                  length={11}
                  verification_type='bvn'
                  data={user}
                  can_verify={!profile.bvn_verified}
                  disabled={isBvnDisabled}
                  value={profile?.bvn || t('N/A')}
                  onChange={() => { }}
                />
              ) : null
            }
            <Information
              {...infoProps}
              title={t('Date of Birth')}
              date
              value={profile?.date_of_birth || t('N/A')}
              onChange={handleChange(profile, 'date_of_birth')}
            />
            <Information
              {...infoProps}
              title={t('Address')}
              value={user?.address || t('N/A')}
              onChange={handleChange(user, 'address')}
            />
            <Information
              {...infoProps}
              title={t('City')}
              value={user?.city || t('N/A')}
              onChange={handleChange(user, 'city')}
            />
            <Information
              {...infoProps}
              title={t('State')}
              value={user?.state || t('N/A')}
              onChange={handleChange(user, 'state')}
            />
            <Information
              {...infoProps}
              title={t('Country')}
              disabled={true}
              value={user?.country || t('N/A')}
              onChange={() => { }}
            />
            <Information
              {...infoProps}
              title={t('Postal Code')}
              value={user?.zip_code || t('N/A')}
              onChange={handleChange(user, 'zip_code')}
            />
            <Information
              {...infoProps}
              title={t('Nationality')}
              value={profile?.nationality || t('N/A')}
              onChange={handleChange(profile, 'nationality')}
            />
            <Information
              {...infoProps}
              title={t('Marital Status')}
              select
              select_array={['Single', 'Married', 'Divorced', 'Widowed']}
              value={profile?.marital_status || t('N/A')}
              onChange={handleChange(profile, 'marital_status')}
            />
            {
              error.length > 0 && (
                error.map((err, index) => (
                  <Text
                    key={index}
                    mb='10px'
                    ms='4px'
                    color={'red'}
                    fontWeight='400'
                    fontSize='md'>
                    * {err.msg}
                  </Text>
                ))
              )
            }
          </SimpleGrid>
        </>
      )}
    </Card>
  );

  // Update profile
  async function updateProfile(key, value, params = {}) {
    setError([]);
    setLoading(true);
    const data = {
      [key]: value,
      ...params || {}
    }
    authentication.updateUser(data, (error, data) => {
      setLoading(false);
      if (error) {
        setError(error.errors);
        constants.showToast(
          "error",
          t('FAILED'),
          error?.message || t('Snap! Something went wrong, Try again')
        );
      } else {
        constants.showToast(
          "success",
          t('SUCCESS'),
          t('Profile updated successfully')
        );
      }
    });
  }
}
